/*
 * Tine 2.0
 * 
 * @license     http://www.gnu.org/licenses/agpl.html AGPL Version 3
 * @author      Alexander Stintzing <a.stintzing@metaways.de>
 * @copyright   Copyright (c) 2013 Metaways Infosystems GmbH (http://www.metaways.de)
 */
Ext.ns('Tine.HumanResources');

/**
 * FreeDay grid panel
 * 
 * @namespace   Tine.HumanResources
 * @class       Tine.HumanResources.FreeDayGridPanel
 * @extends     Tine.widgets.grid.GridPanel
 * 
 * <p>FreeDay Grid Panel</p>
 * <p><pre>
 * </pre></p>
 * 
 * @license     http://www.gnu.org/licenses/agpl.html AGPL Version 3
 * @author      Alexander Stintzing <a.stintzing@metaways.de>    
 * 
 * @param       {Object} config
 * @constructor
 * Create a new Tine.HumanResources.FreeDayGridPanel
 */
Tine.HumanResources.FreeDayGridPanel = Ext.extend(Tine.widgets.grid.GridPanel, {
});
